import CaseTypeRM from '../responsemodel/CaseTypeRM'
import CaseType from '../../models/CaseType'
import DataMapper from './DataMapper'

export default class CaseTypeDataMapper extends DataMapper<CaseTypeRM, CaseType> {
  map = (rm: CaseTypeRM) => new CaseType(rm.id, rm.name, rm.case_category, rm.internal_TAT, rm.investigator_TAT, rm.capping, rm.services, rm.required_documents)
}
